import React from 'react'

function JCards(props) {
  return (
    <div className='flex flex-col  py-12 px-8 ' 
    data-aos="zoom-in" data-aos-offset="200"  data-aos-duration="1000" >
    <div className='py-3'>
      {props.icon}
    </div>
    <h3 className='text-2xl text-center font-semibold py-3'>{props.heading}</h3>
    <p className=' text-lg py-3'>
      {props.text}
    </p>
  </div>
  )
}

export default JCards